import { Card } from "react-bootstrap";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Chart } from "react-chartjs-2";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useMemo } from "react";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
ChartJS.register(ArcElement, Tooltip, Legend, annotationPlugin, ChartDataLabels);

export default function PPMDemographicsCard({ data, loading, error }) {
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                top: 1,
            },
        },
        borderRadius: 5,
        plugins: {
            legend: {
                display: false,
                position: "bottom",
                labels: {
                    usePointStyle: true,
                },
            },
            tooltip: {
                enabled: false,
            },
            datalabels: {
                color: "#142533",
                font: {
                    weight: "bold",
                },
                formatter: function (value) {
                    return `${value.toFixed(2).toLocaleString()}%`;
                },
            },
            annotation: {
                clip: false,
                annotations: {
                    avg: {
                        type: "line",
                        label: {
                            display: true,
                            content: `AVG ${data?.demo_1234.average?.toFixed(2).toLocaleString()}%`,
                            position: "20%",
                            color: "#142533",
                            backgroundColor: "transparent",
                            padding: 0,
                            yAdjust: 8,
                        },
                        yMin: data?.demo_1234.average,
                        yMax: data?.demo_1234.average,
                        xMin: -0.5,
                        xMax: 0.5,
                        borderColor: "#142533",
                        borderWidth: 3,
                    },
                    avg2: {
                        type: "line",
                        label: {
                            display: true,
                            content: `AVG ${data?.demo_1550.average?.toFixed(2).toLocaleString()}%`,
                            position: "20%",
                            color: "#142533",
                            backgroundColor: "transparent",
                            padding: 0,
                            yAdjust: 8,
                        },
                        yMin: data?.demo_1550.average,
                        yMax: data?.demo_1550.average,
                        xMin: 0.5,
                        xMax: 1.5,
                        borderColor: "#142533",
                        borderWidth: 3,
                    },
                    avg3: {
                        type: "line",
                        label: {
                            display: true,
                            content: `AVG ${data?.demo_4099.average?.toFixed(2).toLocaleString()}%`,
                            position: "20%",
                            color: "#142533",
                            backgroundColor: "transparent",
                            padding: 0,
                            yAdjust: 8,
                        },
                        yMin: data?.demo_4099.average,
                        yMax: data?.demo_4099.average,
                        xMin: 1.5,
                        xMax: 2.5,
                        borderColor: "#142533",
                        borderWidth: 3,
                    },
                },
            },
        },
        scales: {
            y: {
                ticks: {
                    display: false,
                },
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
            },
            x: {
                grid: {
                    display: false,
                },
            },
        },

        interaction: {
            mode: "index",
        },
    };

    const chartData = useMemo(() => {
        if (data) {
            return {
                labels: ["12-34", "15-50", "40+"],
                datasets: [
                    {
                        type: "bar",
                        backgroundColor: ["#FEDE86", "#FED971", "#FECE48"],
                        data: [data?.demo_1234.time_frame, data?.demo_1550.time_frame, data?.demo_4099.time_frame],
                    },
                ],
            };
        }
    }, [data]);

    return (
        <Card>
            <Card.Header className="d-flex align-items-center px-2">
                <span className="flex-grow-1">Demographics</span>
            </Card.Header>
            <Card.Body className="card-health-chart d-flex">
                {loading ? <LoadingIndicator width={85} /> : error ? <ErrorResponse errorCode={error} /> : <Chart data={chartData} options={chartOptions} />}
            </Card.Body>
        </Card>
    );
}
